const DB_NAME = 'kinetic_sftp_local_fs';
const DB_VERSION = 1;
const STORE_META = 'meta';
const ROOT_HANDLE_KEY = 'root-handle';

const hasIndexedDb = typeof indexedDB !== 'undefined';

const requestToPromise = (request) =>
new Promise((resolve, reject) => {
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error || new Error('IndexedDB request failed.'));
});

const openDb = () =>
new Promise((resolve, reject) => {
  if (!hasIndexedDb) {
    reject(new Error('IndexedDB is not available in this browser.'));
    return;
  }
  const request = indexedDB.open(DB_NAME, DB_VERSION);
  request.onupgradeneeded = () => {
    const db = request.result;
    if (!db.objectStoreNames.contains(STORE_META)) {
      db.createObjectStore(STORE_META);
    }
  };
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error || new Error('Unable to open IndexedDB.'));
});

const withStore = async (mode, worker) => {
  const db = await openDb();
  try {
    const tx = db.transaction(STORE_META, mode);
    const store = tx.objectStore(STORE_META);
    const result = await worker(store);
    await new Promise((resolve, reject) => {
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error || new Error('IndexedDB transaction failed.'));
      tx.onabort = () => reject(tx.error || new Error('IndexedDB transaction aborted.'));
    });
    return result;
  } finally {
    db.close();
  }
};

export const localDirectoryStore = {
  isSupported() {
    return hasIndexedDb;
  },

  async getRootHandle() {
    if (!hasIndexedDb) return null;
    try {
      return await withStore('readonly', async (store) => requestToPromise(store.get(ROOT_HANDLE_KEY)));
    } catch {
      return null;
    }
  },

  async setRootHandle(handle) {
    if (!hasIndexedDb) return;
    await withStore('readwrite', async (store) => {
      await requestToPromise(store.put(handle, ROOT_HANDLE_KEY));
    });
  },

  async clearRootHandle() {
    if (!hasIndexedDb) return;
    await withStore('readwrite', async (store) => {
      await requestToPromise(store.delete(ROOT_HANDLE_KEY));
    });
  }
};
